<template>
  <div class="home">
    <img src="../assets/img/shou_ye_bg@2x.png" width="861" height="491" alt="">
  </div>
</template>

<script>
import { CheckLogin } from '../api/api'
export default {
  created () {
    this.init()
  },
  methods: {
    async init () {
      await CheckLogin().then(res => {
        console.log(res)
        // 保存用户数据
        localStorage.setItem('user_info', JSON.stringify(res.data))
      })
    }
  }
}
</script>

<style>
.home {
  width: 100%;
  height: 100%;
  background: #9aaeb2;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
